// getLabelTextColor returns a readable text color (black or white) for a given
// label background color, based on its perceived luminance.
export function getLabelTextColor(color:string):string{
	let hex = color || "";
	if (hex[0] != "#") return "#fff";
	hex = hex.slice(1);
	if (hex.length == 3) hex = hex.split("").map(c=>c+c).join("");
	if (hex.length < 6) return "#fff";
	let r = parseInt(hex.slice(0, 2), 16);
	let g = parseInt(hex.slice(2, 4), 16);
	let b = parseInt(hex.slice(4, 6), 16);
	let luminance = (0.299*r + 0.587*g + 0.114*b) / 255;
	return luminance > 0.6 ? "#000" : "#fff";
}

// labelItemHtml renders a label as a dropdown item: a dot in its own color
// followed by the name.
export function labelItemHtml(label:{Name:string, Color:string}):string{
	let name = label.Name.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
	let color = (label.Color || "").replace(/"/g, "");
	return `<span style="display:inline-block;width:10px;height:10px;border-radius:50%;vertical-align:middle;margin-right:8px;background:${color}"></span>${name}`;
}
